export const FETCH_FEEDBACK = 'FETCH_FEEDBACK'



// WEBPACK FOOTER //
// ./src/pages/feedback/constants.ts